import { gql, useMutation } from '@apollo/client';
import { GenderModel } from '@utmost.co/enterprise-models';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';
import { useGenderIntl } from '../translations/useGenderIntl';

const DELETE_GENDER = gql`
  mutation deleteGender($uid: String!) {
    deleteGender(uid: $uid) {
      uid
    }
  }
`;

export const useDeleteGenders = () => {
  const { enqueueSnackbar, showError } = useSnackbar();
  const { deleteSuccess } = useGenderIntl();
  const [deleteGender, { loading }] = useMutation<{ deleteGender: GenderModel }, { uid: string }>(DELETE_GENDER);

  const deleteSelected = async (uids: string[]) => {
    try {
      await Promise.all(uids.map((uid) => deleteGender({ variables: { uid } })));
      enqueueSnackbar(deleteSuccess({ total: uids.length }), {
        variant: 'success'
      });
    } catch (e: any) {
      let message = e.toString();
      if (Array.isArray(e) && e?.[0]?.message) {
        message = e?.[0]?.message;
      }

      showError(message);
    }
  };

  return {
    deleteSelected,
    loading
  };
};
